/**
 * Helpers for page-wide keyboard shortcuts.
 */

// Input types where pressing a letter types it. CurrencyInput and
// PercentageInput are type="text" as well, so their inputmode is checked too.
const TEXT_INPUT_TYPES = new Set(['text', 'search', 'email', 'url', 'password']);
const NUMBER_INPUT_MODES = new Set(['numeric', 'decimal', 'tel']);

/**
 * True when `el` is a box where pressing a letter types that letter: a text
 * input, a textarea or an editable region. A page-wide shortcut on a letter
 * key (like Shift+D) must leave these alone, or typing a capital letter moves
 * the cursor somewhere else instead of typing it.
 */
export function acceptsTypedText(el) {
  if (!el) return false;
  if (el.isContentEditable) return true;
  if (el.tagName === 'TEXTAREA') return !el.readOnly;
  if (el.tagName !== 'INPUT' || el.readOnly) return false;
  const inputMode = (el.getAttribute('inputmode') || '').toLowerCase();
  return TEXT_INPUT_TYPES.has(el.type) && !NUMBER_INPUT_MODES.has(inputMode);
}
